import { useCallback, useEffect, useState } from 'react';

export const useLocalStorage = (key: string, value: any, initialValue: any) => {
  const initialize = (key: string) => {
    try {
      const item = localStorage.getItem(key);

      if (item && item !== 'undefined') {
        return JSON.parse(item);
      }

      localStorage.setItem(key, JSON.stringify(value));

      return value;
    } catch (error) {
      console.error(error);
      return value;
    }
  };

  const [state, setState] = useState<any>(initialValue);

  const setValue = useCallback(
    (value: any) => {
      try {
        setState(value);
        localStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        console.error(error);
      }
    },
    [key, setState]
  );

  const removeValue = useCallback(() => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(error);
    }
  }, [key]);

  useEffect(() => {
    const activeValue = initialize(key);
    setValue(activeValue);
  }, [key]);

  return [state, setValue, removeValue];
};
